import type { Role } from "~/types/groups"

// Colored by the user's highest-priority role: the backend orders roles ascending by `position`
// (bigger string = more senior, @everyone always last/most senior - see GroupActor.CanManageRoleAsync
// on the backend), so picking the user's highest-priority role means sorting DESCENDING and taking
// the first match. Uses ordinal comparison to match the backend's StringComparer.Ordinal - a locale
// comparer could disagree with it for some characters. @everyone is excluded from that scan even
// though it's positionally "most senior": every user has it, so leaving it in would make it match
// first for everyone and mask their actual role color. It's only used as the color fallback when
// the user has no other role. Shared by every place that names a user by role color: the member
// list, message author, interaction caller, and @mentions.
export function getRoleColor(roles: Role[] | undefined, roleIds: string[] | undefined): string | undefined {
  if (!roles?.length) return undefined
  const ordered = [...roles]
    .filter((r) => r.name !== "@everyone")
    .sort((a, b) => b.position < a.position ? -1 : b.position > a.position ? 1 : 0)
  const role = ordered.find((r) => roleIds?.includes(r.id)) || roles.find((r) => r.name === "@everyone")
  return role?.color || "#99aab5"
}
